const state = {
  averageScore: null,
  scoresMap: { '1': 0, '2': 0, '3': 0, '4': 0, '5': 0 },
  isLoadingScoreSummary: true
};

const getters = {
  scoredReviewsCount({ scoresMap }) {
    return Object.values(scoresMap).reduce((a, v) => a + v, 0);
  },
  averageScoreText({ averageScore }) {
    return averageScore !== null ? averageScore.toFixed(1) : null;
  }
};

const mutations = {
  SET_AVERAGE_SCORE(state, averageScore) {
    state.averageScore = averageScore;
  },
  SET_SCORES_MAP(state, scoresMap) {
    state.scoresMap = scoresMap;
  },
  SET_IS_LOADING_SCORE_SUMMARY(state, isLoadingScoreSummary) {
    state.isLoadingScoreSummary = isLoadingScoreSummary;
  }
};

const actions = {
  fetchProductScoreSummary({ commit, rootState }, params) {
    const product_code = rootState.productCode;
    const widget_id = rootState.widget.widget.id;
    commit('SET_IS_LOADING_SCORE_SUMMARY', true);
    rootState.api
      .fetchProductScore(product_code, widget_id, params?.fields || '')
      .then(({ data }) => {
        commit('SET_AVERAGE_SCORE', data.average_score);
        if (data.scores_map) {
          commit('SET_SCORES_MAP', data.scores_map);
        }
      })
      .finally(() => {
        commit('SET_IS_LOADING_SCORE_SUMMARY', false);
      });
  }
};

export default { namespaced: true, state, getters, mutations, actions };
